'use strict';

angular.module('mean.bids').factory('Bids', ['$resource',
	function ($resource) {
		return $resource('/api/bids/:bidId', {
			bidId: '@_id'
		}, {
				update: {
					method: 'PUT'
				}
			});
	}
]);

angular.module('mean.bids').factory('Options', ['$resource',
	function ($resource) {
		return $resource('/api/options/:optionId', {
			optionId: '@_id'
		}, {
				update: {
					method: 'PUT'
				}
			});
	}
]);

angular.module('mean.bids').factory('BidMaterialsSaves', ['$resource',
	function ($resource) {
		return $resource('/api/bidmaterialssaves/:bidmaterialssaveId', {
			bidmaterialssaveId: '@_id'
		}, {
				update: {
					method: 'PUT'
				}
			});
	}
]);

angular.module('mean.bids').factory('TradeBids', ['$resource',
	function ($resource) {
		return $resource('/api/tradebids/:tradebidsId', {
			tradebidsId: '@_id'
		}, {
				update: {
					method: 'PUT'
				}
			});
	}
]);

angular.module('mean.bids').factory('BidWizardEdit', function () {
	var savedData = {};

	function set(data) {
		savedData = data;
	}
	function get() {
		return savedData;
	}

	return {
		set: set,
		get: get
	};

});

angular.module('mean.bids').factory('BidRequestEdit', function () {
	var savedData = {};

	function set(data) {
		savedData = data;
	}
	function get() {
		return savedData;
	}

	return {
		set: set,
		get: get
	};

});

angular.module('mean.bids').factory('BidBuilderReview', function () {
	var savedData = {};

	function set(data) {
		savedData = data;
	}
	function get() {
		return savedData;
	}

	return {
		set: set,
		get: get
	};

});

angular.module('mean.bids').factory('BidOldReview', function () {
	var savedData = {};

	function set(data) {
		savedData = data;
	}
	function get() {
		return savedData;
	}

	return {
		set: set,
		get: get
	};

});

angular.module('mean.bids').factory('BidRequestReview', function () {
	var savedData = {};

	function set(data, trade) {
		savedData = data;
		savedData.review_trade_index = trade;
	}
	function get() {
		return savedData;
	}

	return {
		set: set,
		get: get
	};

});

/*angular.module('mean.bids').factory('postBuilderEmailForm', ['$http', function($http) {
	return {
		postBuilderEmail: function(emailData, callback) {
			$http.post('/postBuilderEmail', emailData).success(callback);
		}
	}
}]);*/



// WEBPACK FOOTER //
// ./packages/custom/bids/public/services/bids.js